/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-12 20:08:46
 * @FilePath: /insuranceagent-ui/src/util/version.js
 * @Description: 更新版本
 */
//每10分钟获取一次version 数据，和本地数据做比较，如果version 数据和本地数据不一致，就更新本地数据。
//强制更新！！
import config from '@/../version.json'
import {getVersion} from '@/api/login'

export function getVersionData() {
	return new Promise(async (resolve, reject) => {
		try {
			let tempData = (await getVersion()) || {}
			let {status, data: {update = '0'} = {}} = tempData
			// 本地数据
			let tempCode = config.update || '0'
			console.log(status, `请求版本-${update}---`, `本地版本-${tempCode}`)
			//比较tempcode和update 大小。类型string
			if (status === 200 && tempCode !== update) {
				//需要更新本地数据
				resolve()
			}
			reject()
		} catch (e) {
			console.error('getVersionData------', e)
			reject(e)
		}
	})
}
